import React from "react"
import ValidateDocuments from "./validate-documents"

const ValidateDocumentsKyc = () => <ValidateDocuments kyc />

export default ValidateDocumentsKyc
